import RoboChat from '../../../../icons/RoboChat.svg';
import review from '../../../../icons/review.svg';
import reviewPolicy from '../../../../icons/reviewPolicy2.svg';
import reviewApproval from '../../../../icons/reviewApproval.svg';
import shieldProtected3 from '../../../../icons/shieldProtected3.svg';
import receiveCall from '../../../../icons/receiveCall.svg';
import submitApplication from '../../../../icons/submitApplication.svg';
import printPolicy from "../../../../icons/printPolicy.svg";
import onlineApplication from '../../../../icons/onlineApplication.svg';
import Approved from '../icons/approved.svg';
import paymentinfo from '../icons/paymentInfo.svg';
import NotApproved from '../icons/notApproved.svg';
import SignApplication from '../icons/signApplication.svg';
import ConditionApproval from '../icons/conditionalApproval.svg';
import SubmitRequestIcon from "../../../../icons/submitRequest.svg";
import TimeRequiredIcon from "../../../../icons/timeRequired.svg";
import MedicalProcedureIcon from "../../../../icons/medicalProcedure.svg";
import CarrierRatingIcon from "../../../../icons/carrierRating.svg";
import SecureInformationIcon from "../../../../icons/secureInformation.svg";

export const EasyStepsSchedule = [
  {
    text: "Receive a call from the Covr team to review your quotes",
    icon: receiveCall
  },
  {
    text: "Review your options and coverage details",
    icon: review
  },
  {
    text: "Submit your application for approval",
    icon: submitApplication
  },
  {
    text: "Receive and review your policy",
    icon: reviewPolicy
  },
  {
    text: "Pay and activate your coverage",
    icon: shieldProtected3
  },
];

export const EasyStepsConfirmation = [
  {
    text: "Get your quote when our licensed insurance professional calls you",
    icon: receiveCall
  },
  {
    text: "Complete your application over the phone",
    icon: onlineApplication
  },
  {
    text: "Complete the carrier underwriting process/requirements",
    icon: reviewApproval
  },
  {
    text: "Once approved, you may print and file your policy!",
    icon: printPolicy
  },
];

export const InsurancePlan = [
  {
    title: "Want coverage for another person?",
    content: "Getting your spouse or partner insured can be just as important as your own insurance.",
    icon: RoboChat,
    btnTitle: 'GET A QUOTE',
    linkTo: '/landing/universal-life'
  },
  {
    title: "Other Insurance Options",
    content: "Explore coverage options in a variety of categories, all from your mobile device.",
    icon: RoboChat,
    btnTitle: 'SEE PRODUCTS',
    linkTo: '/'
  },
  {
    title: "Policy Review",
    content: "If you have existing life insurance coverage, we provide a complimentary policy review service to ensure your coverage meets your needs / budget.",
    icon: RoboChat,
    btnTitle: 'GET A POLICY REVIEW',
    linkTo: '/policy-review'
  },
];

export const UnderwritingList = [
  {
    title: "One of three outcomes will be made:",
    sublist: [
      {
        subtitle: "Approved at the rate you applied for",
        icon: Approved,
      },
      {
        subtitle: "Approved at a rate different than you applied for",
        icon: ConditionApproval,
      },
      {
        subtitle: "Not approved",
        icon: NotApproved,
      }
    ]
  },
  {
    title: "If approved, you can activate your coverage by following the next steps:",
    sublist: [
      {
        subtitle: "Enter your payment information for your policy",
        icon: paymentinfo,
      },
      {
        subtitle: "Sign your application",
        icon: SignApplication,
      },
    ]
  },
];

export const StepList = [
  {
    title: "Complete your entire application online",
    icon: SubmitRequestIcon,
    sublist: [
      {
        subtitle: "It only takes about 15 minutes!"
      }
    ]
  },
  {
    title: "Have the following information handy:",
    icon: onlineApplication,
    sublist: [
      {
        subtitle: "Your driver’s license and SSN"
      },
      {
        subtitle: "The name of your Doctor(s)"
      },
      {
        subtitle: "The name of any medications that you’re taking"
      }
    ]
  },
  {
    title: "Electronically sign your application",
    icon: reviewApproval,
  }
];

export const RotatingSteps = [
  {
    text: "Congratulations on submitting your application!  Americo is now hard at work reviewing your  information…"
  },
  {
    text: "Our cutting-edge technology is scanning various databases to avoid the need of a medical exam while providing a quick and accurate decision on your application."
  },
  {
    text: "For over 100 years, Americo has been committed to providing life insurance products to protect families across the country."
  },
  {
    text: "Using advanced underwriting tools, the review process has been reduced from weeks to minutes."
  },
  {
    text: "The information you shared is safe-guarded and only used by parties in order to provide a decision on your policy."
  },
  {
    text: "All the data utilized by Americo complies with the Fair Credit Reporting Act and is used by all insurance companies today."
  },
  {
    text: "Americo is an “A” Rated (3rd highest) by A.M. Best with over $7 billion in assets"
  },
  {
    text: "Assuming you are approved and accept the offer, it easy to activate your coverage by electronically signing your policy and setting up your initial payment."
  },
  {
    text: "Once your policy is activated, your life insurance policy documents will be physically mailed from the life insurance company."
  },
  {
    text:"Almost done!  We look forward to finalizing your life insurance coverage!"
  }
];

export const PlanFeatures = [
  {
    icon: TimeRequiredIcon,
    text: "Get your policy today with an all digital process."
  },
  {
    icon: MedicalProcedureIcon,
    text: "Instant decision, no needles or checkups."
  },
  {
    icon: CarrierRatingIcon,
    text: "AM Best has rated this carrier as A"
  },
  {
    icon: SecureInformationIcon,
    text: "End-to-end 256-bit encryption protects you every step of the way"
  },
];



// WEBPACK FOOTER //
// ./src/components/Quoters/AmericoLoanProtection/Helpers/Constant.js